import axios from "config/axios";
import { Company, GenericResponse } from "shared/types";
import { CompanyShopAddressRequest } from "./company.api";

const ENDPOINT = "/relshopaddress";

export const relshopaddressCompany = (data: CompanyShopAddressRequest) =>
  axios.post<GenericResponse<Company>>(`${ENDPOINT}/save`, data);
